export default __webpack_public_path__ + "static/media/P620_C_BD.32b589ad.pdf";